(function(){
    'use strict'

    angular
    .module('app.departamentos')
    .controller('Departamentos', Departamentos);

    Departamentos.$inject = ['$animationsSrv', 'DepartamentosService', 'logger', '$location', 'UserInfoService'];

    function Departamentos($animationsSrv, DepartamentosService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.departamentos = [];
        vm.title = 'Departamentos';

        vm.goToEdit = function(departamento){
            
            var path = '/editar-departamento/';

            if(departamento){
                $location.path(path + departamento.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = DepartamentosService.getAll(UserInfoService.getCompaniaId());

            promise
            .then(function(departamentos){
                vm.departamentos = departamentos;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los departamentos.');
                        break;
                }
            });
        };

        vm.delete = function(departamento){
            var promise = DepartamentosService.remove(departamento);
            
            promise
            .then(function(response){
                vm.departamentos = vm.departamentos.filter(function(g) {
                    return g.id !== departamento.id;
                });
                logger.success('Departamento eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Departamento');
                        break;
                }
                
            });   
        };

    }
})();